import React from "react";

import {DishDetailsItem} from "@apps/dish/interfaces";

import {useUser} from "@globals/user";

import {MenuType} from "@components/Menu/interfaces";

import useDishDetailsConfig from "../hooks/useDishDetailsConfig";
import styles from "./SoldoutFavoritePrompt.scss";

const showPromptOnMenuType = (menuType: MenuType) =>
  menuType === MenuType.Extras || menuType === MenuType.Individual;

export default function SoldoutFavoritePrompt({
  dish,
}: {
  dish: DishDetailsItem;
}): JSX.Element {
  const config = useDishDetailsConfig();
  const {user} = useUser();

  if (user && dish.soldout && showPromptOnMenuType(config.menuType)) {
    return (
      <div className={styles.container}>
        {dish.is_favorite ? (
          <a className={styles.text} href="/my-account/notifications">
            Update your Favorites notifications settings here
          </a>
        ) : (
          <span className={styles.text}>
            Add this dish to your Favorites to be notified the next time it's on
            the menu!
          </span>
        )}
      </div>
    );
  }

  return <></>;
}
